import React from 'react'

class Social extends React.Component {
	render() {
		return (
			<nav className="social">
				<a href="https://www.facebook.com/Downingtown-East-Theatre-151960198191336" className="facebook">Facebook</a>
				<a href="https://twitter.com/DEast_Theatre" className="twitter">Twitter</a>
				{/*<a href="/" className="youtube">Youtube</a>*/}
				<a href="https://www.instagram.com/dehs_theatre/" className="instagram">Instagram</a>
				{/*<a href="/" className="pinterest">Pinterest</a>*/}
				<a href="mailto:downingtowneasttheatre@gmail.com" className="email">downingtowneasttheatre@gmail.com</a>
			</nav>
		)
	}
}

export default Social



// WEBPACK FOOTER //
// ./src/components/social.js